// Horizontal scroll row with prev/next commands (--prev / --next) that move by about one view.
// Buttons disable at the ends. Swipe, trackpad and shift+wheel scrolling work natively.
class ScrollRow extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const track = this.querySelector('[data-scroll-track]');
    if (!track) return;
    const prev = this.querySelector('[data-scroll-prev]');
    const next = this.querySelector('[data-scroll-next]');
    const controls = this.querySelector('[data-scroll-controls]');
    const rtl = () => getComputedStyle(track).direction === 'rtl';
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max;
      // Hide the arrows entirely when every card already fits on screen.
      if (controls) controls.style.display = max <= 0 ? 'none' : '';
    };
    this.addEventListener(
      'command',
      (event) => {
        const dir = event.command === '--next' ? 1 : event.command === '--prev' ? -1 : 0;
        if (!dir) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: dir * track.clientWidth * 0.9 * (rtl() ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
      },
      { signal }
    );
    // Review photos hosted by apps can expire; drop any that fail so no empty boxes remain.
    const dropBroken = (img) => {
      const link = img.closest('a') || img;
      const grid = link.parentElement;
      link.remove();
      if (grid && grid.children.length === 0) grid.remove();
      else if (grid && grid.children.length === 1) grid.classList.replace('grid-cols-2', 'grid-cols-1');
    };
    track.addEventListener('error', (event) => {
      if (event.target instanceof HTMLImageElement) dropBroken(event.target);
    }, { capture: true, signal });
    track.querySelectorAll('img').forEach((img) => {
      if (img.complete && img.naturalWidth === 0) dropBroken(img);
    });
    track.addEventListener('scroll', update, { passive: true, signal });
    window.addEventListener('resize', update, { signal });
    // Re-check when photos load or cards are removed, since the row width can change.
    const observer = new ResizeObserver(update);
    observer.observe(track);
    signal.addEventListener('abort', () => observer.disconnect());
    update();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-scroll-row')) {
  customElements.define('s-scroll-row', ScrollRow);
}
